import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function updateDeliveryDate({ testWorkQueueId, deliveryDate }) {
  const axios = axiosInstance().primoLab;
  const { data } = await axios.post('/clinic-deliveries/update-delivery-date', {
    test_work_queue_id: testWorkQueueId,
    delivery_date: deliveryDate,
  });
  return data;
} 